import emptySelectOption from '@/constants/emptySelectOption';
import { Person, PersonMinimal } from '@/types/person';
import { OptionType } from '@/ui/components/Form/Select/types';

import formatPersonName from './formatPersonName';

export const formatPersonToSelectOption = (
  person: Person | PersonMinimal | null | undefined
): OptionType<string> => {
  if (person) {
    const name = formatPersonName({ person, withNickname: true });
    return {
      label: name,
      value: person.id,
      avatar: person.profile_image_url ? person.profile_image_url : null
    };
  } else {
    return emptySelectOption;
  }
};
